<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  props: {
    data: {
      required: true,
    },
    option: {
      required: true,
    },
  },
  watch: {
    data: function dataChanged(val) {
      this.renderChart(this.data, this.option);
    },
  },
};
</script>
